var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('dashboard-core-app-bar'),_c('dashboard-core-drawer',{attrs:{"expand-on-hover":_vm.expandOnHover}}),_c('alerts'),_c('dashboard-core-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }